import {
    Button,
    CardContent,
    Grid,
    IconButton,
    makeStyles,
    Modal,
    Paper,
    TextField,
    Typography
} from "@material-ui/core";
import React, { useContext } from "react";
import { Close } from "@material-ui/icons";
import * as Yup from "yup";
import { useFormik } from "formik";
import AppState from '../../context/AppContext';
const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: '360px',
        backgroundColor: 'white',
        color: 'black',
        '& .MuiFormHelperText-root': {
            color: 'black',
        },
        '& .Mui-error': {
            color: 'black',
        },
    },
    errorText: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    card: {
        marginTop: '20px',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        margin: 'auto',
        maxWidth: '420px',
        padding: theme.spacing(2),
    },
    typography: {
        marginTop: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardModal: {
        width: '100%',
    },
    closeButton: {
        float: 'right'
    },
}));

const EditChildGift = ( props ) => {
    const classes = useStyles();
    const context = useContext( AppState );
    const validationSchema = Yup.object().shape( {
        childGift: Yup.string().required( "Gift is required" ),
    } );

    const childGift = context.store.currentGift;
    const handleClose = () => {
        props.handleClose();
        resetForm();
    };
    const onSubmit = ( values ) => {
        context.store.children.map(child => {
            if (child.list.includes(context.store.currentGift)) {
                const index = child.list.findIndex(gift => gift === context.store.currentGift)
                child.list.splice(index, 1)
                child.list.push(values.childGift)
            }
       return undefined })
        values.childGift = "";
        context.store.editGift = false;
        context.setStore({
            ...context.store,
        })
        handleClose();
    };
    const {
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        resetForm
    } = useFormik( {
        initialValues: {
            childGift: childGift
        },
        validationSchema: validationSchema,
        onSubmit,
    } );
    return (
        <Modal open={props.open} className={classes.modal}>
            <Paper className={classes.paper}>
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <Close/>
                </IconButton>
                <Paper className={classes.card}>
                    <Typography variant="h5">Edit Child</Typography>
                    <CardContent>
                        <form onSubmit={handleSubmit} autoComplete="off" className={classes.form}>
                            <TextField
                                name="childGift"
                                defaultValue={childGift}
                                onChange={handleChange}
                                id="childGift"
                                label="Present"
                                type="text"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                placeholder="What would you like?"
                                onBlur={handleBlur}
                                className={classes.input}
                                error={!!(touched.childGift && errors.childGift)}
                                helperText={touched.childGift && errors.childGift}
                            />
                            <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" onClick={handleClose}>
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Paper>
            </Paper>
        </Modal>
    );
};

export default EditChildGift;
